module.exports = __webpack_public_path__ + "img/cwwdog.ee333f5d.jpg";